'use strict';

import TermUtils from '@uw-it-sis/lib-react/lib/TermUtils';

/**
 * Utility methods for notification related stuff.
 */
const NotifyUtils = {};

/**
 * Convert an ActivityOffering ID to a SurrogateID as used by notification service
 * (see edu.uw.kuali.student.myplan.util.UwCourseHelper.getSurrogateIdForActivityId())
 */
NotifyUtils.getSurrogateIdForActivityId = function(activityId) {
    let surrogateId = activityId.toLowerCase();
    let surrogateItems = surrogateId.split(":");
    if (surrogateItems.length === 5) {
        surrogateId = `${surrogateItems[0]},${TermUtils.TERMS[surrogateItems[1]].toLowerCase()},${surrogateItems[2]},${surrogateItems[3]},${surrogateItems[4]}`;
    }
    return surrogateId;
};

NotifyUtils.protocols = ["email", "sms"];

export default NotifyUtils;